var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconPopupHandStopNewVersion(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 79,
    viewBox: "0 0 65 79",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "open-hand 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M58.2598 13.7391C55.4144 13.7391 53.1077 16.0458 53.1077 18.8912V12.0218C53.1077 9.17634 50.8009 6.86961 47.9555 6.86961C45.11 6.86961 42.8033 9.17634 42.8033 12.0218V5.15217C42.8033 2.30672 40.4966 0 37.6511 0C34.8057 0 32.499 2.30672 32.499 5.15217V12.0218C32.499 9.17634 30.1922 6.86961 27.3468 6.86961C24.5014 6.86961 22.1946 9.17634 22.1946 12.0218V48.087L10.2691 42.1241C9.07688 41.5279 7.76211 41.2175 6.42899 41.2174C3.75421 41.2174 1.58595 43.3856 1.58595 46.0604V46.081C1.58321 47.3691 2.09376 48.6051 3.00457 49.5157L25.2138 71.725C29.8802 76.3867 36.2074 79.0035 42.8033 78.9998C54.1851 78.9998 63.412 69.7729 63.412 58.3912V18.8912C63.412 16.0458 61.1054 13.7391 58.2598 13.7391Z",
    fill: "url(#paint0_linear_4715_6426)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M32.5001 36.0655C33.4485 36.0655 34.2175 35.2965 34.2175 34.348V1.33984C33.1198 2.30201 32.4933 3.69278 32.5001 5.15245V36.0655Z",
    fill: "#FEA500"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M42.8047 36.065C43.7532 36.065 44.5222 35.296 44.5222 34.3476V8.20898C43.4244 9.17115 42.798 10.5619 42.8047 12.0216V36.065Z",
    fill: "#FEA500"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M53.1094 18.8917V36.0657C54.0579 36.0657 54.8269 35.2967 54.8269 34.3482V15.0791C53.7293 16.0413 53.1027 17.4322 53.1094 18.8917Z",
    fill: "#FEA500"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4715_6426",
    x1: 30.2718,
    y1: 4.18614,
    x2: 51.766,
    y2: 95.1542,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6D061"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEA500"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPopupHandStopNewVersion);
export default __webpack_public_path__ + "static/media/icon_popup_hand_stop_new_version.0a4422abca20b0bb389cffe6975fde31.svg";
export { ForwardRef as ReactComponent };